import { createBaseInputNamespace } from '../BaseInput';
import { InputTypes } from '../enums/InputTypes';
export var TextInput = createBaseInputNamespace(InputTypes.Text);